/* eslint-disable default-param-last */
import {
  OPCOES_TELA_RENDA,
  OPCOES_CARD,
  RESETA_OPCOES_TELA_RENDA,
  OPCOES_TELA_BENEFICIARIOS,
} from './constants';

const initialState = {
  telaSimulacaoConversao: false,
  tipoRendaMensal: 0,
  percentualRendaMensal: '',
  mesesAposentar: '',
  percentualContribuicao: 0,
  remuneracaoMensal: 0,
  crescimentoSalario: 0,
  remuneracoesAno: 0,
  retornoInvestimento: 0,
  percentualSaque: 0,
  prazoRendaTemporaria: 0,
  percentualrcm: '',
  percentualSaldoVitalicio: '',
  beneficiariosChecked: [],
};

export default function simulacaoBeneficio(state = initialState, action) {
  switch (action.type) {
    case OPCOES_TELA_RENDA:
      return {
        ...state,
        ...action.values,
      };
    case OPCOES_CARD:
      return {
        ...state,
        ...action.values,
        tipoRendaMensal: action.values.tipoRendaMensal,
      };
    case OPCOES_TELA_BENEFICIARIOS:
      return {
        ...state,
        beneficiariosChecked: action.values,
      };
    case RESETA_OPCOES_TELA_RENDA:
      return initialState;
    default:
      return state;
  }
}
